import Vue from "vue";
import axios from 'axios';

const version = 'v1';
const getAllChannelsApi = `${version}/channel/getAll`;
const addChannelsApi = `${version}/channel/add`;
const updateChannelsApi = `${version}/channel/update`;
const deleteChannelsApi = `${version}/channel/delete`;

export const state = Vue.observable({
    channels: [],
    channelsCount: 0
});

export const mutations = {
    async setChannels(params = {}) {
        var res = await axios.post(getAllChannelsApi, params);
        state.channels = res?.data?.result?.items;
        state.channelsCount = res.data.result.totalCount;
    },
    async addChannel(channel) {
        await axios.post(addChannelsApi, channel);
        await this.setChannels();
    },
    async updateChannel(channel) {
        await axios.put(updateChannelsApi, channel);
        await this.setChannels();
    },
    async deleteChannel(channelId) {
        await axios.delete(`${deleteChannelsApi}/${channelId}`);
        await this.setChannels();
    }
};